module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/gCZPMc/images/cover.jpg?1701092164997",
      "alt": "This image is the cover for the book Venging"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Venging\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Hailed by readers and critics alike, "), _c('i', [_vm._v("The Venging")]), _vm._v(" has been described as an “excellent collection” and its author praised as “one of the freshest writers to break into the science fiction field in many a year.” ")]), _c('br'), _c('br'), _vm._v(" This is the first published collection of short stories by one of the foremost voices in science fiction today. This significant volume contains many characters and situations that later evolved into their own novels. “Mandala” features technologically perfect cities that eject their sinful human occupants, a premise that can be found at the root of Bear’s later novel, Strength of Stones. In “Hardfought,” Bear brilliantly handles the classic science fiction dilemma of human communication with aliens. Other stories include “The Wind From a Burning Woman” in which a woman holds the world hostage by controlling a giant asteroid; “Scattershot,” in which the inhabitants of many universes meet in an undefined limbo space; and the Nebula Award finalist “Petra,” a story of a world where chaos rules, stone moves, and the mind controls reality."), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Greg Bear\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Greg Bear has won two Hugo Awards and three Nebula Awards and is a past president to the Science Fiction Writers of America. He lives in Seattle, Washington.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Open Road Media\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0